import client from './client';
import { CompanySettings, Company, User, InviteRequest } from '../types';

export const adminApi = {
  getSettings: () => client.get<CompanySettings>('/admin/settings'),

  updateSettings: (data: Partial<CompanySettings>) =>
    client.put<CompanySettings>('/admin/settings', data),

  uploadLogo: (formData: FormData) =>
    client.post<{ logo_url: string }>('/admin/logo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),

  getCompany: () => client.get<Company>('/admin/company'),

  updateCompany: (data: Partial<Company>) =>
    client.put<Company>('/admin/company', data),

  getUsers: () => client.get<User[]>('/admin/users'),

  inviteUser: (data: InviteRequest) =>
    client.post('/admin/users/invite', data),

  updateUserRole: (userId: string, role: string) =>
    client.put(`/admin/users/${userId}/role`, { role }),

  deactivateUser: (userId: string) =>
    client.put(`/admin/users/${userId}/deactivate`),
};
